import * as React from 'react';

const Translate = require('react-redux-i18n').Translate;

import { ContentWrapper, ContentButton, LinkToDownloadsPage, ButtonContainer } from '../styles';
import { NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';
import Utils from '../../../utils';


interface ContentProps {
	message: string;
	isDownloading: boolean;
	linkToDownloadsPage: string | undefined;
	onContinueClick: () => void;
	onCancelClick: () => void;
	isCheckingForUpdates: boolean;
}

const Content = ({
 isDownloading,
 message,
 linkToDownloadsPage,
 onContinueClick,
 onCancelClick,
 isCheckingForUpdates,
}: ContentProps) => (
	<ContentWrapper>
		<div className="icon-and-text">
			{isCheckingForUpdates && Utils.getSvgIcon('iconset_loading')}
			<Translate
				value={isCheckingForUpdates ? 'messages.checking_for_updates' : message}
				dangerousHTML={true}
			/>
		</div>
		{isDownloading && linkToDownloadsPage && !isCheckingForUpdates &&
		  <LinkToDownloadsPage
			  value="messages.download_toast_link_to_downloads"
			  url={linkToDownloadsPage}
			  dangerousHTML={true}
		  />
		}
		{!isDownloading && !isCheckingForUpdates &&
		  <ButtonContainer>
			<ContentButton
			  type="button"
			  onClick={onContinueClick}
			  backgroundColor={hexToRgba(NewStyleColor.Blue50, 70)}
			>
			  <Translate value="messages.continue" />
			</ContentButton>
			<ContentButton
			  type="button"
			  onClick={onCancelClick}
			  backgroundColor={hexToRgba(NewStyleColor.Grey300, 70)}
			  color={NewStyleColor.Grey500}
			>
			  <Translate value="messages.cancel" />
			</ContentButton>
		  </ButtonContainer>
		}
	</ContentWrapper>
);

export default Content;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DownloadGroupToast/Content/index.tsx